import { POST } from "../../utils/constants/verbs";
import { put, takeLatest } from "redux-saga/effects";
import requestAPI from "../../helpers/requestHelpers";
import { Types } from "../ducks/disclaimer";
import urls from "../../utils/constants/urlsAPI";
function* requestDisclaimers({payload}) {
  try {
    const response = yield requestAPI({
      verb: POST,
      endPoint: urls.sendLeedEmail,
      data: {email: payload.email , event_presential_id: payload.id}
    });
  } catch (e) {
    yield put({
      type: Types.DISCLAIMERS_REQUEST_FAIL,
      error: e
    });
  }
}

export function* watcherSaga() {
  yield takeLatest(Types.DISCLAIMERS_REQUEST, requestDisclaimers);
}
